export const SPARK_VERIFICATION_ID = 1
export const KASPI_VERIFICATION_ID = 2
